// import React, { useEffect, useState } from 'react';
// import Select from 'react-select';
// import SweetAlert from '../../Shared/Notification';
// import OptionModal from '../../Modals/OptionModal';
// import SupplierSelectionModal from '../../Modals/SupplierSelectionModal';
// import { useNavigate, useParams } from 'react-router-dom';
// import APIService from '../../../Services/APIService';
// import TableHeader from '../../Shared/TableHeader';
// import { BackButton } from '../../Shared/BackButton';
// import { Form, Button, Row, Col, FormGroup, FormCheck, FormLabel } from 'react-bootstrap';
// import SelectDropdown from '../../Shared/SelectDropdown';
// import ErrorWrapper from '../../Shared/ErrorWrapper/index';
// import ConfirmBox from '../../Shared/Notification/ConfirmBox'; // Import the ConfirmBox component

// const CreateBaseType = () => {
//   const params = useParams();
//   const navigation = useNavigate();
//   const [state, setState] = useState({
//     name: '',
//     supplier_attributes: [{ name: '', type: '', is_required: false, is_editable: true }],
//     showOptionModal: false,
//     attributeOptions: [''],
//     attributeInfo: {},
//     selectedModalSupplierType: undefined,
//     showSupplierSelectionModal: false,
//     errors: {},
//   });
//   const { errors } = state;

//   const optionStyle = {
//     fontSize: '12px',
//     margin: '0',
//     marginTop: '5px',
//     textDecoration: 'underline',
//     cursor: 'pointer',
//     paddingBottom: '10px',
//   };

//   const AttributeTypes = [
//     { value: 'STRING', label: 'Text' },
//     { value: 'FLOAT', label: 'Float' },
//     { value: 'DROPDOWN', label: 'Dropdown' },
//     { value: 'EMAIL', label: 'Email' },
//     { value: 'BASE_SUPPLIER_TYPE', label: 'Base Supplier Type' },
//     { value: 'DATETIME', label: 'Date' },
//   ];

//   const getAttributeTypeOption = (value) => {
//     for (let i = 0, l = AttributeTypes.length; i < l; i += 1) {
//       if (AttributeTypes[i].value === value) {
//         return AttributeTypes[i];
//       }
//     }
//     return null;
//   };

//   const validate = async (data) => {
//     const errors = {};
//     if (!data.name.trim()) {
//       errors.name = {
//         message: 'Please enter a name for standard template',
//       };
//     }

//     for (let i = 0; i < data.supplier_attributes.length; i++) {
//       let attr = 'attribute' + i;
//       let type = 'type' + i;
//       if (!data.supplier_attributes[i].name) {
//         errors[attr] = {
//           message: 'This field should not be blank',
//         };
//       }
//       if (!data.supplier_attributes[i].type) {
//         errors[type] = {
//           message: 'Please select the type',
//         };
//       }
//       if (
//         (data.supplier_attributes[i].type === 'DROPDOWN') &&
//         (!data.supplier_attributes[i].hasOwnProperty('options') ||
//           data.supplier_attributes[i].options.length === 0 ||
//           data.supplier_attributes[i].options.indexOf('') > -1)
//       ) {
//         let opt = 'options' + i;
//         errors[opt] = {
//           message: 'Please fill the options',
//         };
//       }
//     }

//     return errors;
//   };

//   const onCancelOptionModal = () => {
//     setState({
//       ...state,
//       showOptionModal: false,
//       attributeOptions: [''],
//       attributeInfo: {},
//     });
//   };

//   const handleAttributeChange = (attribute, index) => {
//     let supplierAttributes = [...state.supplier_attributes];
//     let attributes = supplierAttributes.slice();
//     attributes.splice(index, 1, attribute);

//     setState({
//       ...state,
//       supplier_attributes: attributes,
//     });
//   };

//   const onSubmitOptionModal = (options, attributeInfo) => {
//     let newAttributes = Object.assign({}, attributeInfo.attribute, {
//       type: attributeInfo.attributeType,
//       options: options,
//     });
//     handleAttributeChange(newAttributes, attributeInfo.attrIndex);
//     setState({
//       ...state,
//       showOptionModal: false,
//       attributeOptions: [''],
//       attributeInfo: {},
//     });
//   };

//   const onOpenOptionModal = (options, attributeType, attribute, attrIndex) => {
//     setState({
//       ...state,
//       showOptionModal: true,
//       attributeOptions: options,
//       attributeInfo: {
//         attributeType,
//         attribute,
//         attrIndex,
//       },
//     });
//   };

//   const onCancelSupplierModal = () => {
//     setState({
//       ...state,
//       showSupplierSelectionModal: false,
//       attributeInfo: {},
//     });
//   };

//   const onSubmitSupplierModal = (value, attributeInfo) => {
//     setState({
//       ...state,
//       showSupplierSelectionModal: false,
//       attributeInfo: {},
//     });

//     let newAttributes = Object.assign({}, attributeInfo.attribute, {
//       type: attributeInfo.attributeType,
//       value,
//     });
//     handleAttributeChange(newAttributes, attributeInfo.attrIndex);
//   };

//   const onOpenSupplierModal = (attributeType, attribute, attrIndex) => {
//     setState({
//       ...state,
//       showSupplierSelectionModal: true,
//       selectedModalSupplierType: attribute.value,
//       attributeInfo: {
//         attributeType,
//         attribute,
//         attrIndex,
//       },
//     });
//   };

//   const postBaseSupplierType = async (data) => {
//     let res = await APIService.post(`/v0/ui/dynamic-suppliers/base-supplier-type/`, data);
//     if (res.status === 200) {
//       SweetAlert('Base Supplier Type created successfully', 'success');
//       navigation('/r/supplier/base-type/list');
//     }
//   };

//   const updateSupplierType = async (data) => {
//     let res = await APIService.put(
//       `/v0/ui/dynamic-suppliers/base-supplier-type/${params.baseSupplierTypeId}/`,
//       data
//     );
//     if (res.status === 200) {
//       SweetAlert('Base Supplier Type updated successfully', 'success');
//       navigation('/r/supplier/base-type/list');
//     }
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();

//     const userConfirmed = await ConfirmBox({
//       title: 'Submit Form?',
//       text: 'Are you sure you want to submit the form?',
//       icon: 'question',
//       confirmButtonText: 'Submit',
//       cancelButtonText: 'Cancel',
//     });

//     if (!userConfirmed) {
//       return;
//     }

//     let data = {
//       name: state.name,
//       supplier_attributes: state.supplier_attributes,
//     };

//     const errors = await validate(data);
//     if (Object.keys(errors).length) {
//       setState({
//         ...state,
//         errors,
//       });
//     } else {
//       if (params.baseSupplierTypeId) updateSupplierType(data);
//       else postBaseSupplierType(data);
//     }
//   };

//   const onAddAttribute = () => {
//     let newAttributes = [...state.supplier_attributes];
//     newAttributes = newAttributes.slice();
//     newAttributes.push({
//       name: '',
//       type: 'STRING',
//       is_required: false,
//       is_editable: true,
//     });

//     setState({
//       ...state,
//       supplier_attributes: newAttributes,
//     });
//   };

//   const onRemoveAttribute = async (index) => {
//     const userConfirmed = await ConfirmBox({
//       title: 'Remove Attribute?',
//       text: 'Are you sure you want to remove this attribute?',
//       icon: 'warning',
//       confirmButtonText: 'Remove',
//       cancelButtonText: 'Cancel',
//     });

//     if (!userConfirmed) {
//       return;
//     }

//     let newAttributes = [...state.supplier_attributes];
//     newAttributes = newAttributes.slice();
//     newAttributes.splice(index, 1);
//     setState({
//       ...state,
//       supplier_attributes: newAttributes,
//     });
//   };

//   const handleInputChange = (e) => {
//     setState({
//       ...state,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const getBaseSupplierType = async (id) => {
//     let res = await APIService.get(`/v0/ui/dynamic-suppliers/base-supplier-type/${id}/`);
//     if (res.status === 200) {
//       setState((prevState) => ({
//         ...prevState,
//         currentBaseSupplierType: res?.data?.id,
//         supplier_attributes: res?.data?.supplier_attributes,
//         name: res?.data?.name,
//       }));
//     }
//   };

//   useEffect(() => {
//     if (params.baseSupplierTypeId) getBaseSupplierType(params.baseSupplierTypeId);
//   }, []);

//   const renderAttributeRow = (attribute, attrIndex) => {
//     const { errors } = state;
//     const onNameChange = (event) => {
//       const newAttribute = Object.assign({}, attribute);
//       newAttribute.name = event.target.value;
//       handleAttributeChange(newAttribute, attrIndex);
//     };

//     const onTypeChange = (item) => {
//       if (item.value === 'DROPDOWN') {
//         setState({
//           ...state,
//           showOptionModal: true,
//           columnOptions: [''],
//           attributeInfo: {
//             attributeType: item.value,
//             attribute,
//             attrIndex,
//           },
//         });
//       } else if (
//         item.value === 'BASE_SUPPLIER_TYPE' ||
//         item.value === 'INVENTORY_TYPE' ||
//         item.value === 'INVENTORY'
//       ) {
//         setState({
//           ...state,
//           showSupplierSelectionModal: true,
//           attributeInfo: {
//             attributeType: item.value,
//             attribute,
//             attrIndex,
//           },
//         });
//         return;
//       }
//       const newAttribute = Object.assign({}, attribute);
//       newAttribute.type = item.value;
//       handleAttributeChange(newAttribute, attrIndex);
//     };

//     const onRequiredChange = (event) => {
//       const newAttribute = {
//         ...attribute,
//         is_required: !!event.target.checked,
//       };
//       handleAttributeChange(newAttribute, attrIndex);
//     };

//     const onEditableChange = (event) => {
//       const newAttribute = {
//         ...attribute,
//         is_editable: !!event.target.checked,
//       };
//       handleAttributeChange(newAttribute, attrIndex);
//     };

//     return (
//       <Row key={`row-${attrIndex}`}>
//         <Col>
//           <FormGroup className="my-2">
//             <Form.Control
//               type="text"
//               placeholder="Name"
//               name="name"
//               value={attribute?.name || ''}
//               onChange={(e) => onNameChange(e)}
//             />
//           </FormGroup>
//           {errors && errors['attribute' + attrIndex] ? (
//             <ErrorWrapper error={errors['attribute' + attrIndex].message} />
//           ) : null}
//         </Col>
//         <Col>
//           <SelectDropdown
//             optionsData={AttributeTypes}
//             isClearable={false}
//             placeholder={'Select'}
//             selectedValue={getAttributeTypeOption(attribute.type)}
//             handleSelect={onTypeChange}
//           />
//           {errors && errors['type' + attrIndex] ? (
//             <ErrorWrapper error={errors['attribute' + attrIndex].message} />
//           ) : null}
//           {attribute.type === 'DROPDOWN' ? (
//             <p
//               className="show-option"
//               style={optionStyle}
//               onClick={() =>
//                 onOpenOptionModal(attribute.options, attribute.type, attribute, attrIndex)
//               }
//             >
//               Show Options
//             </p>
//           ) : (
//             ''
//           )}
//           {errors && errors['options' + attrIndex] ? (
//             <ErrorWrapper error={errors['options' + attrIndex].message} />
//           ) : null}
//           {attribute.type === 'BASE_SUPPLIER_TYPE' ||
//           attribute.type === 'INVENTORY_TYPE' ||
//           attribute.type === 'INVENTORY' ? (
//             <p
//               className="show-option"
//               style={optionStyle}
//               onClick={() => onOpenSupplierModal(attribute.type, attribute, attrIndex)}
//             >
//               Show Attributes
//             </p>
//           ) : (
//             ''
//           )}
//         </Col>
//         <Col>
//           <FormGroup className="inline my-1.5 border border-primary p-2">
//             <Form.Check
//               type="checkbox"
//               id={`required${attrIndex}`}
//               name="option"
//               label={'Is it required ?'}
//               checked={attribute.is_required}
//               onChange={(e) => onRequiredChange(e)}
//             />
//           </FormGroup>
//         </Col>
//         <Col>
//           <FormGroup className="inline my-1.5 border border-primary p-2">
//             <Form.Check
//               type="checkbox"
//               id={`editable${attrIndex}`}
//               name="option"
//               label={'Is it editable ?'}
//               checked={attribute.is_editable}
//               onChange={(e) => onEditableChange(e)}
//             />
//           </FormGroup>
//         </Col>
//         <Col>
//           <Button
//             type="button"
//             className="btn btn-primary mt-1"
//             onClick={() => onRemoveAttribute(attrIndex)}
//           >
//             Remove Attribute
//           </Button>
//         </Col>
//       </Row>
//     );
//   };

//   const backButton = () => {
//     return <BackButton onClick={() => navigation(`/r/supplier/base-type/list`)} />;
//   };

//   return (
//     <>
//       <TableHeader headerValue={`Create Standard Template`} isBackButton={backButton} />
//       <Form onSubmit={onSubmit}>
//         <Form.Label>
//           Enter Name For Base Supplier Type <span className="required-field">*</span>
//         </Form.Label>
//         <Form.Control
//           type="text"
//           name="name"
//           placeholder="Enter Name For Base Supplier Type"
//           value={state.name}
//           onChange={(e) => handleInputChange(e)}
//         />
//         {state.errors?.name ? (
//           <ErrorWrapper error={state?.errors?.name?.message} />
//         ) : null}
//         <Form.Label className="form-label">Attributes</Form.Label>
//         <div>{state.supplier_attributes && state.supplier_attributes.map(renderAttributeRow)}</div>
//         <Button variant="primary" onClick={onAddAttribute} style={{ marginRight: '10px' }}>
//           Add Attribute
//         </Button>
//         <Button type="submit" variant="primary">
//           Submit
//         </Button>
//       </Form>
//       <OptionModal
//         key={state?.attributeInfo?.attrIndex}
//         showOptionModal={state.showOptionModal}
//         onCancel={onCancelOptionModal}
//         onSubmit={onSubmitOptionModal}
//         options={state.attributeOptions}
//         columnInfo={state.attributeInfo}
//       />
//       {state.showSupplierSelectionModal ? (
//         <SupplierSelectionModal
//           showOptionModal={state.showSupplierSelectionModal}
//           onCancel={onCancelSupplierModal}
//           onSubmit={onSubmitSupplierModal}
//           attributeInfo={state.attributeInfo}
//           selectedModalSupplierType={state.selectedModalSupplierType}
//         />
//       ) : undefined}
//     </>
//   );
// };

// export default CreateBaseType;

import React, { useEffect, useState } from 'react';
import OptionModal from '../../Modals/OptionModal';
import SupplierSelectionModal from '../../Modals/SupplierSelectionModal';
import { useNavigate, useParams } from 'react-router-dom';
import APIService from '../../../Services/APIService';
import { BackButton } from '../../Shared/BackButton';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import { Box, Button, Checkbox, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import ConfirmBox from '../../FlowBuilder/Common/ConfirmBox/index.tsx';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';

const CreateBaseType = () => {
  const params = useParams();
  const navigation = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState({});
  const [confirmPromiseResolver, setConfirmPromiseResolver] = useState(null);
  const [state, setState] = useState({
    name: '',
    supplier_attributes: [{ name: '', type: '', is_required: false, is_editable: true }],
    showOptionModal: false,
    attributeOptions: [''],
    attributeInfo: {},
    selectedModalSupplierType: undefined,
    showSupplierSelectionModal: false,
    errors: {},
  });
  const { errors } = state;
  const { showSnackBar } = useSnackBar();
  const optionStyle = {
    fontSize: '12px',
    margin: '0',
    marginTop: '5px',
    textDecoration: 'underline',
    cursor: 'pointer',
    paddingBottom: '10px',
  };

  const AttributeTypes = [
    { value: 'STRING', label: 'Text' },
    { value: 'FLOAT', label: 'Float' },
    { value: 'DROPDOWN', label: 'Dropdown' },
    { value: 'EMAIL', label: 'Email' },
    { value: 'BASE_SUPPLIER_TYPE', label: 'Base Supplier Type' },
    { value: 'DATETIME', label: 'Date' },
  ];

  const getAttributeTypeOption = (value) => {
    for (let i = 0, l = AttributeTypes.length; i < l; i += 1) {
      if (AttributeTypes[i].value === value) {
        return AttributeTypes[i];
      }
    }
    return null;
  };

  const validate = async (data) => {
    const errors = {};
    if (!data.name.trim()) {
      errors.name = {
        message: 'Please enter a name for standard template',
      };
    }

    for (let i = 0; i < data.supplier_attributes.length; i++) {
      let attr = 'attribute' + i;
      let type = 'type' + i;
      if (!data.supplier_attributes[i].name) {
        errors[attr] = {
          message: 'This field should not be blank',
        };
      }
      if (!data.supplier_attributes[i].type) {
        errors[type] = {
          message: 'Please select the type',
        };
      }
      if (
        (data.supplier_attributes[i].type === 'DROPDOWN') &&
        (!data.supplier_attributes[i].hasOwnProperty('options') ||
          data.supplier_attributes[i].options.length === 0 ||
          data.supplier_attributes[i].options.indexOf('') > -1)
      ) {
        let opt = 'options' + i;
        errors[opt] = {
          message: 'Please fill the options',
        };
      }
    }

    return errors;
  };

  const onCancelOptionModal = () => {
    setState({
      ...state,
      showOptionModal: false,
      attributeOptions: [''],
      attributeInfo: {},
    });
  };

  const handleAttributeChange = (attribute, index) => {
    let supplierAttributes = [...state.supplier_attributes];
    let attributes = supplierAttributes.slice();
    attributes.splice(index, 1, attribute);

    setState({
      ...state,
      supplier_attributes: attributes,
    });
  };

  const onSubmitOptionModal = (options, attributeInfo) => {
    let newAttributes = Object.assign({}, attributeInfo.attribute, {
      type: attributeInfo.attributeType,
      options: options,
    });
    handleAttributeChange(newAttributes, attributeInfo.attrIndex);
    setState({
      ...state,
      showOptionModal: false,
      attributeOptions: [''],
      attributeInfo: {},
    });
  };

  const onOpenOptionModal = (options, attributeType, attribute, attrIndex) => {
    setState({
      ...state,
      showOptionModal: true,
      attributeOptions: options,
      attributeInfo: {
        attributeType,
        attribute,
        attrIndex,
      },
    });
  };

  const onCancelSupplierModal = () => {
    setState({
      ...state,
      showSupplierSelectionModal: false,
      attributeInfo: {},
    });
  };

  const onSubmitSupplierModal = (value, attributeInfo) => {
    setState({
      ...state,
      showSupplierSelectionModal: false,
      attributeInfo: {},
    });

    let newAttributes = Object.assign({}, attributeInfo.attribute, {
      type: attributeInfo.attributeType,
      value,
    });
    handleAttributeChange(newAttributes, attributeInfo.attrIndex);
  };

  const onOpenSupplierModal = (attributeType, attribute, attrIndex) => {
    setState({
      ...state,
      showSupplierSelectionModal: true,
      selectedModalSupplierType: attribute.value,
      attributeInfo: {
        attributeType,
        attribute,
        attrIndex,
      },
    });
  };

  const postBaseSupplierType = async (data) => {
    let res = await APIService.post(`/v0/ui/dynamic-suppliers/base-supplier-type/`, data);
    if (res.status === 200) {
      showSnackBar('Base Supplier Type created successfully', 'success');
      navigation('/r/supplier/base-type/list');
    }
  };

  const updateSupplierType = async (data) => {
    let res = await APIService.put(
      `/v0/ui/dynamic-suppliers/base-supplier-type/${params.baseSupplierTypeId}/`,
      data
    );
    if (res.status === 200) {
      showSnackBar('Base Supplier Type updated successfully', 'success');
      navigation('/r/supplier/base-type/list');
    }
  };
  const showConfirmation = (options) => {
    return new Promise((resolve) => {
      setConfirmOptions(options); // set dynamic confirm options
      setShowConfirm(true);
      setConfirmPromiseResolver(() => resolve);
    });
  };

  const handleConfirmClose = (result) => {
    setShowConfirm(false);
    if (confirmPromiseResolver) confirmPromiseResolver(result);
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const userConfirmed = await showConfirmation({
      title: 'Submit Form?',
      text: 'Are you sure you want to submit the form?',
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'error',
      cancelButtonColor: 'primary',
    });

    if (!userConfirmed) return;

    let data = {
      name: state.name,
      supplier_attributes: state.supplier_attributes,
    };

    const errors = await validate(data);
    if (Object.keys(errors).length) {
      setState({
        ...state,
        errors,
      });
    } else {
      if (params.baseSupplierTypeId) updateSupplierType(data);
      else postBaseSupplierType(data);
    }
  };

  const onAddAttribute = () => {
    let newAttributes = [...state.supplier_attributes];
    newAttributes = newAttributes.slice();
    newAttributes.push({
      name: '',
      type: 'STRING',
      is_required: false,
      is_editable: true,
    });

    setState({
      ...state,
      supplier_attributes: newAttributes,
    });
  };

  const onRemoveAttribute = async (index) => {
    const userConfirmed = await showConfirmation({
      title: 'Remove Attribute?',
      text: 'Are you sure you want to remove this attribute?',
      confirmButtonText: 'Remove',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'error',
      cancelButtonColor: 'primary',
    });
    if (!userConfirmed) {
      return;
    }
    let newAttributes = [...state.supplier_attributes];
    newAttributes = newAttributes.slice();
    newAttributes.splice(index, 1);
    setState({
      ...state,
      supplier_attributes: newAttributes,
    });
  };

  const handleInputChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const getBaseSupplierType = async (id) => {
    let res = await APIService.get(`/v0/ui/dynamic-suppliers/base-supplier-type/${id}/`);
    if (res.status === 200) {
      setState((prevState) => ({
        ...prevState,
        currentBaseSupplierType: res?.data?.id,
        supplier_attributes: res?.data?.supplier_attributes,
        name: res?.data?.name,
      }));
    }
  };

  useEffect(() => {
    if (params.baseSupplierTypeId) getBaseSupplierType(params.baseSupplierTypeId);
  }, []);

  const renderAttributeRow = (attribute, attrIndex) => {
    const { errors } = state;
    const onNameChange = (event) => {
      const newAttribute = Object.assign({}, attribute);
      newAttribute.name = event.target.value;
      handleAttributeChange(newAttribute, attrIndex);
    };

    const onTypeChange = (item) => {
      if (!item) return;
      if (item.value === 'DROPDOWN') {
        setState({
          ...state,
          showOptionModal: true,
          columnOptions: [''],
          attributeInfo: {
            attributeType: item.value,
            attribute,
            attrIndex,
          },
        });
      } else if (
        item.value === 'BASE_SUPPLIER_TYPE' ||
        item.value === 'INVENTORY_TYPE' ||
        item.value === 'INVENTORY'
      ) {
        setState({
          ...state,
          showSupplierSelectionModal: true,
          attributeInfo: {
            attributeType: item.value,
            attribute,
            attrIndex,
          },
        });
        return;
      }
      const newAttribute = Object.assign({}, attribute);
      newAttribute.type = item.value;
      handleAttributeChange(newAttribute, attrIndex);
    };

    const onRequiredChange = (event) => {
      const newAttribute = {
        ...attribute,
        is_required: !!event.target.checked,
      };
      handleAttributeChange(newAttribute, attrIndex);
    };

    const onEditableChange = (event) => {
      const newAttribute = {
        ...attribute,
        is_editable: !!event.target.checked,
      };
      handleAttributeChange(newAttribute, attrIndex);
    };

    return (
      <Grid container spacing={2} key={`row-${attrIndex}`} alignItems="center" sx={{ mb: 2 }}>
        {/* Attribute Name Field */}
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Name"
            slotProps={{
              inputLabel: {
                sx: { top: '-7px' }
              }
            }}
            name="name"
            variant="outlined"
            value={attribute?.name || ''}
            onChange={(e) => onNameChange(e)}
            error={!!errors?.[`attribute${attrIndex}`]}
            helperText={errors?.[`attribute${attrIndex}`]?.message || ''}
            InputProps={{
              sx: {
                '& input': {
                  padding: '8px',
                },
                
              },
            }}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <SearchableDropdown
            options={AttributeTypes}
            value={getAttributeTypeOption(attribute.type) || null}
            onChange={onTypeChange}
            label="Select"
            labelKey="label"
            valueKey="value"
            isClearable={false}
            size="small"
          />
          {errors?.[`type${attrIndex}`] && (
            <Typography variant="body2" color="error">
              {errors?.[`type${attrIndex}`]?.message}
            </Typography>
          )}
          {attribute.type === 'DROPDOWN' && (
            <Typography
              onClick={() =>
                onOpenOptionModal(attribute.options, attribute.type, attribute, attrIndex)
              }
              sx={{ cursor: 'pointer', color: 'primary.main', mt: 1 }}
            >
              Show Options
            </Typography>
          )}

          {errors?.[`options${attrIndex}`] && (
            <Typography variant="body2" color="error">
              {errors?.[`options${attrIndex}`]?.message}
            </Typography>
          )}
          {['BASE_SUPPLIER_TYPE', 'INVENTORY_TYPE', 'INVENTORY'].includes(attribute.type) && (
            <Typography
              onClick={() => onOpenSupplierModal(attribute.type, attribute, attrIndex)}
              sx={{ cursor: 'pointer', color: 'primary.main', mt: 1 }}
            >
              Show Attributes
            </Typography>
          )}
        </Grid>
        <Grid item xs={6} md={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={attribute.is_required}
                onChange={onRequiredChange}
                name="required"
              />
            }
            label="Is it required?"
          />
        </Grid>
        <Grid item xs={6} md={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={attribute.is_editable}
                onChange={onEditableChange}
                name="editable"
              />
            }
            label="Is it editable?"
          />
        </Grid>
        <Grid item xs={6} md={2}>
          <Button
            variant="contained"
            color="primary"
            size='small'
            onClick={() => onRemoveAttribute(attrIndex)}
          >
            Remove Attribute
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px',p:1 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item sx={{mb:1}}>
          <Typography variant="h4" fontWeight="bold">
            Create Standard Template
          </Typography>
        </Grid>
        <Grid item>
          <BackButton onClick={() => navigation(`/r/supplier/base-type/list`)} />
        </Grid>
      </Grid>
      <Box component="form" onSubmit={onSubmit} noValidate>
        
        <Typography variant="subtitle1" gutterBottom sx={{mb:1}}>
          Enter Name For Base Supplier Type <span style={{ color: 'red' }}>*</span>
        </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label="Name"
            slotProps={{
                inputLabel: {
                  sx: { top: '-7px' }
                }
              }}
            name="name"
            placeholder="Enter Name For Base Supplier Type"
            value={state.name}
            onChange={handleInputChange}
            error={Boolean(state.errors?.name)}
            helperText={state.errors?.name?.message || ''}
            InputProps={{
                    sx: {
                      '& input': {
                        padding: '8px',
                      },
                    },
                  }}
          />

        <Typography variant="subtitle1" className="form-label" gutterBottom sx={{my:1}}>
          Attributes
        </Typography>

        <Box sx={{ mb: 2 }}>
          {state.supplier_attributes?.map(renderAttributeRow)}
        </Box>

        <Grid container spacing={2} mb={2} sx={{ justifyContent:{xs:'space-between', sm:'normal'} }}>
          <Grid item>
            <Button variant="contained" size="small" onClick={onAddAttribute}>
              Add Attribute
            </Button>
          </Grid>
          <Grid item>
            <Button type="submit" size="small" variant="contained" color="primary">
              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
      <OptionModal
        key={state?.attributeInfo?.attrIndex}
        showOptionModal={state.showOptionModal}
        onCancel={onCancelOptionModal}
        onSubmit={onSubmitOptionModal}
        options={state.attributeOptions}
        columnInfo={state.attributeInfo}
      />
      {state.showSupplierSelectionModal ? (
        <SupplierSelectionModal
          showOptionModal={state.showSupplierSelectionModal}
          onCancel={onCancelSupplierModal}
          onSubmit={onSubmitSupplierModal}
          attributeInfo={state.attributeInfo}
          selectedModalSupplierType={state.selectedModalSupplierType}
        />
      ) : undefined}

      <ConfirmBox
        open={showConfirm}
        onClose={handleConfirmClose}
        options={confirmOptions}
      />


    </Box>
  );
};

export default CreateBaseType;

